import { css } from '@emotion/react';
import sctheme from 'app/styles/sctheme';

const styles = sctheme => css`
  .batch-list-item {
    display: flex;
    justify-content: space-between;
  }

  .input-wrap {
    max-width: 95%;
  }

  .trash-can {
    cursor: pointer;
    color: ${sctheme.grays.$600};
  }

  .trash-can:hover {
    color: ${sctheme.red};
  }

  .group-label {
    background-color: ${sctheme.blues.primaryLight}80;
    color: ${sctheme.grays.$900};
    font-size: 0.875rem;
    text-transform: uppercase;
    border-top: 1px solid ${sctheme.grays.$300};
    font-weight: bold;
  }

  .batch-description {
    font-size: 0.875rem;
    color: ${sctheme.grays.$600};
  }
`;

export default styles(sctheme);
